import { DocumentOrientation } from "pages/flyer/builder/drawer/types";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const PdfJS = require("pdfjs-dist/legacy/build/pdf.min");
PdfJS.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PdfJS.version}/pdf.worker.min.js`;

// An uploaded PDF that has no builder room yet auto-imports into a Portrait canvas by
// default — so a landscape design comes in rotated/shrunk. Read the PDF's real
// orientation so the caller can store it (and pass it as a URL param) before navigating
// and the canvas opens to match. Shared by both add-address-box entry points
// (creative/pageV2 DesignSelection and the campaign-creation flyerTypePage flow).
export const detectPdfOrientation = async (url: string): Promise<DocumentOrientation | null> => {
  try {
    const pdf = await PdfJS.getDocument(url).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1 });
    return viewport.width >= viewport.height ? DocumentOrientation.Landscape : DocumentOrientation.Portrait;
  } catch {
    return null;
  }
};
